import { CONSTANTS } from '../data';
import { GameState } from '../systems/GameState';
import { EffectsSystem } from '../systems/EffectsSystem';
import { typeAIMessage } from '../utils/typeText';

export class ChainReactionSystem {
  private gameState = GameState.getInstance();
  private effectsSystem = new EffectsSystem();

  public checkChainReaction(
    newElement: string,
    currentDiscovered: Set<string>,
    setDiscovered: React.Dispatch<React.SetStateAction<Set<string>>>,
    unlockedAchievements: Set<string>,
    shownChapters: Set<string>,
    shownMoralEvents: Set<string>
  ): boolean {
    const reactions = CONSTANTS.CHAIN_REACTIONS as Record<string, string[]>;
    const chain = reactions[newElement];

    if (!chain) return false;

    const newDiscoveries = chain.filter(element => !currentDiscovered.has(element));

    if (newDiscoveries.length === 0) return false;

    const message = `Chain reaction initiated by ${newElement}...`;
    typeAIMessage(message, currentDiscovered);
    
    this.gameState.pauseGame();

    newDiscoveries.forEach((element, index) => {
      setTimeout(() => {
        setDiscovered(prev => new Set(prev).add(element));
        this.effectsSystem.createChainEffect(element);

        const discoveryMessage = `${element} emerged from the reaction!`;
        typeAIMessage(discoveryMessage, new Set([...currentDiscovered, ...newDiscoveries]));
        
        if (index === newDiscoveries.length - 1) {
          setTimeout(() => {
            this.gameState.resumeGame();
            this.gameState.saveGame(
              new Set([...currentDiscovered, ...newDiscoveries]),
              unlockedAchievements,
              shownChapters,
              shownMoralEvents
            );
            const finalMessage = "Chain reaction complete. System stable.";
            typeAIMessage(finalMessage, new Set([...currentDiscovered, ...newDiscoveries]));
          }, 1000);
        }
      }, CONSTANTS.CHAIN_REACTION_EFFECT.delayMs * (index + 1));
    });

    return true;
  }
}
